export default __webpack_public_path__ + "static/media/NU-SC300BMPQ_Spec 1.ef7618fb.jpg";